import { QueryParams } from '../entities';
import queryString, { ParseOptions, StringifyOptions } from 'query-string';
import { runningClientSide } from '@benzinga/utils';

const URL_FORMAT_OPTIONS: StringifyOptions = {
  arrayFormat: 'bracket-separator',
  skipEmptyString: true,
  skipNull: true,
};

const PARSE_OPTIONS_BRACKET_SEPARATOR: ParseOptions = {
  ...URL_FORMAT_OPTIONS,
  parseBooleans: true,
  parseNumbers: true,
} as ParseOptions;

const PARSE_OPTIONS_DUPLICATE_KEYS = {
  parseBooleans: true,
  parseNumbers: true,
  skipEmptyString: true,
  skipNull: true,
} as ParseOptions;

function mergePreferDuplicateKeyArrays(bracketParsed: QueryParams, duplicateFriendlyParsed: QueryParams): QueryParams {
  const merged: QueryParams = { ...bracketParsed };
  for (const [key, value] of Object.entries(duplicateFriendlyParsed)) {
    if (Array.isArray(value)) merged[key] = value;
  }
  return merged;
}

function parseLocationSearchMerged(search: string): QueryParams {
  const normalized = search.startsWith('?') ? search : `?${search}`;
  return mergePreferDuplicateKeyArrays(
    queryString.parse(normalized, PARSE_OPTIONS_BRACKET_SEPARATOR),
    queryString.parse(normalized, PARSE_OPTIONS_DUPLICATE_KEYS),
  );
}

export const getURLParams = (url?: string): QueryParams => {
  try {
    if (url) {
      const bracketParsed = queryString.parseUrl(url, PARSE_OPTIONS_BRACKET_SEPARATOR);
      const dupParsed = queryString.parseUrl(url, PARSE_OPTIONS_DUPLICATE_KEYS);
      return mergePreferDuplicateKeyArrays(bracketParsed.query, dupParsed.query);
    }
    if (runningClientSide()) {
      return parseLocationSearchMerged(window.location.search);
    }

    return {};
  } catch {
    return {};
  }
};

export const formatURL = (searchParams: QueryParams | string): URL | string => {
  if (!runningClientSide()) {
    return '';
  }

  const location = new URL(String(window?.location));
  let url = `${location.origin}${location.pathname}`;
  let query = searchParams;

  if (typeof searchParams !== 'string' && Object.keys(searchParams).length) {
    query = queryString.stringify(searchParams, URL_FORMAT_OPTIONS);
  }

  if (query?.length) {
    url += `?${query}`;
  }

  return new URL(url);
};
